// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import HrDashboardHome from "./HrDashboardHome";
// import LiveJobpost from "../../pages/LiveJobpost";
// import Blackprofile from "../../pages/Blackprofile";
// import Blackprofileapplication from "../../pages/Blackprofileapplication";
// import JobApplication from "../../pages/JobApplication";
// import BlackProfileView from "../../pages/Blackprofileview";
// import Hrlivetraining from "../../pages/Hrlivetraining";
// import Hrliveevents from "../../pages/Hrliveevents";
// import Hrjobfairs from "../../pages/Hrjobfairs";
// import Hrtrainapplication from "../../pages/Hrtrainapplication";
// import Hreventregister from "../../pages/Hreventregister";
// import HremployeeRegistration from "../../pages/HremployeeRegistration";
// import TotalResponses from "../Student/pages/TotalResponses";
// import CandidateProfileview from "../Student/pages/CandidateProfileview";
// import TrainingProgram from "../Student/pages/TrainingProgram";
// import TraingprogramRegistration from "../Student/pages/TraingprogramRegistration";
// import Hrevents from "../Student/pages/Hrevents";
// import Jobfairregisterform from "../Student/pages/Jobfairregisterform";
// import EventRegistration from "../Student/pages/EventRegistration";




// function HrDashboardRoutes() {
//   return (

//     <Routes>
//       <Route path="/" element={<HrDashboardHome />} />
//       <Route path="Livejobpost" element={<LiveJobpost />} />
//       <Route path="JobApplication" element={<JobApplication />} />
//       <Route path="HremployeeRegistration" element={<HremployeeRegistration />} />
//       <Route path="Blackprofile" element={<Blackprofile />} /> /* Black Profile list */
//       <Route path="Blackprofileapplication" element={<Blackprofileapplication />} /> /* Black Profile Application*/
//       <Route path="Blackprofileview" element={<BlackProfileView />} />
//       <Route path="/Hrlivetraining" element={<Hrlivetraining />} />
//       <Route path="/Hrliveevents" element={<Hrliveevents />} />
//       <Route path="/Hrjobfairs" element={<Hrjobfairs />} />
//       <Route path="/Hrtrainapplication" element={<Hrtrainapplication />} />
//       <Route path="/Hreventregister" element={<Hreventregister />} />
//       <Route path="TotalResponses/:jobId" element={<TotalResponses />} />
//       <Route path="/CandidateProfile/:id"  element={<CandidateProfileview />}/>
//       <Route path="/TrainingProgram" element={<TrainingProgram />} />
//       <Route path="/TraingprogramRegistration" element={<TraingprogramRegistration />} />
//       <Route path="/Hrevents" element={<Hrevents />} />
//       <Route path="/EventRegistration" element={<EventRegistration />} />
//       <Route path="/Hrjobfairs" element={<Hrjobfairs />} />
//       <Route path="/Jobfairregisterform" element={<Jobfairregisterform />} />

//     </Routes>
//   );
// }

// export default HrDashboardRoutes;

import React from "react";
import { Routes, Route } from "react-router-dom";
import HrDashboardHome from "./HrDashboardHome";
import LiveJobpost from "../../pages/LiveJobpost";
import Blackprofile from "../../pages/Blackprofile";
import Blackprofileapplication from "../../pages/Blackprofileapplication";
import JobApplication from "../../pages/JobApplication";
import BlackProfileView from "../../pages/Blackprofileview";
import Hrlivetraining from "../../pages/Hrlivetraining";
import Hrliveevents from "../../pages/Hrliveevents";
import Hrjobfairs from "../../pages/Hrjobfairs";
import Hrtrainapplication from "../../pages/Hrtrainapplication";
import Hreventregister from "../../pages/Hreventregister";
import HremployeeRegistration from "../../pages/HremployeeRegistration";
import TotalResponses from "../Student/pages/TotalResponses";
import CandidateProfileview from "../Student/pages/CandidateProfileview";
import TrainingProgram from "../Student/pages/TrainingProgram";
import TraingprogramRegistration from "../Student/pages/TraingprogramRegistration";
import Hrevents from "../Student/pages/Hrevents";
import Jobfairregisterform from "../Student/pages/Jobfairregisterform";
import EventRegistration from "../Student/pages/EventRegistration";

function HrDashboardRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HrDashboardHome />} />
      <Route path="HrDashboardHome" element={<HrDashboardHome />} />
      <Route path="Livejobpost" element={<LiveJobpost />} />
      <Route path="JobApplication" element={<JobApplication />} />
      <Route path="HremployeeRegistration" element={<HremployeeRegistration />} />
      <Route path="Blackprofile" element={<Blackprofile />} />
      <Route path="Blackprofileapplication" element={<Blackprofileapplication />} />
      <Route path="Blackprofileview" element={<BlackProfileView />} />
      <Route path="Hrlivetraining" element={<Hrlivetraining />} />
      <Route path="Hrliveevents" element={<Hrliveevents />} />
      <Route path="Hrjobfairs" element={<Hrjobfairs />} />
      <Route path="Hrtrainapplication" element={<Hrtrainapplication />} />
      <Route path="Hreventregister" element={<Hreventregister />} />
      <Route path="TotalResponses/:jobId" element={<TotalResponses />} />
      <Route path="CandidateProfile/:id" element={<CandidateProfileview />} />
      <Route path="TrainingProgram" element={<TrainingProgram />} />
      <Route path="TraingprogramRegistration" element={<TraingprogramRegistration />} />
      <Route path="Hrevents" element={<Hrevents />} />
      <Route path="EventRegistration" element={<EventRegistration />} />
      <Route path="Jobfairregisterform" element={<Jobfairregisterform />} />
    </Routes>
  );
}

export default HrDashboardRoutes;